<div class="group">
    <div class="group-header" (click)="toggle()">
        <span class="group-label">{{ label }}</span>
        <span class="chevron" [class.open]="open">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
        </span>
    </div>
    <div class="group-body-wrap" [class.open]="open">
        <div class="group-body-inner">
            <ul class="m-menu__subnav">
                @for (child of filteredItems; track child) {
                    <li class="d-flex align-items-center gap-2">
                        <i
                            class="fa fa-thumb-tack"
                            [ngStyle]="{
                                color: pinnedDashboards.includes(child.id) ? '#bf9000' : '#7e94ac',
                                transform: 'rotate(-45deg)',
                                cursor: 'pointer',
                            }"
                            (click)="togglePin.emit(child.id)"
                            [title]="pinnedDashboards.includes(child.id) ? 'Unpin' : 'Pin'">
                        </i>
                        <a
                            routerLink="/products/{{ child.product }}/dashboard/{{ child.id }}"
                            onclick="$('.offcanvas').offcanvas('hide')">
                            <i class="m-menu__link-icon menu_icon" [class]="iconClass"></i>
                            {{ child.name }}
                        </a>
                    </li>
                }
            </ul>
        </div>
    </div>
</div>
